module.exports = __webpack_public_path__ + "static/media/49_B.41ec5d3e.png";